import React, { useState } from 'react'
import { supabase } from '../../../utils/supabaseClient'
import styles from './cityForm.module.css'

const CityForm: React.FC = () => {
    const [cityName, setCityName] = useState('')
    const [message, setMessage] = useState('')

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()
        setMessage('')

        if (!cityName.trim()) {
            setMessage('City name is required')
            return
        }

        try {
            const { data, error } = await supabase
                .from('cities')
                .insert([{ city: cityName.trim() }])
                .select()

            if (error) throw error

            console.log('City added:', data)
            setMessage('City added successfully!')
            setCityName('')
        } catch (error) {
            if (error instanceof Error) {
                setMessage('Failed to add city: ' + error.message)
            } else {
                setMessage('An unknown error occurred')
            }
        }
    }

    return (
        <div className={styles.formContainer}>
            <h2>Add New City</h2>
            <form onSubmit={handleSubmit}>
                <div className={styles.formGroup}>
                    <label htmlFor="cityName">City Name:</label>
                    <input
                        type="text"
                        id="cityName"
                        value={cityName}
                        onChange={(e) => setCityName(e.target.value)}
                        required
                    />
                </div>
                <button type="submit" className={styles.submitButton}>Add City</button>
            </form>
            {message && <p className={styles.message}>{message}</p>}
        </div>
    )
}

export default CityForm